export default "__VITE_ASSET__BSob5GVx__"